import { Skeleton } from '@mui/material'

export const Loading = () => <Skeleton height="38px" variant="rectangular" width="340px" />
